import { Component, Input, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { StoreService } from 'app/services';
import { DayOfWeekEnum } from 'app/models';
import { Utils } from 'app/utils';
import { cl } from '@fullcalendar/core/internal-common';

@Component({
    selector: 'partner-mart-locations-store-hours',
    templateUrl: './partner-mart-locations-store-hours.component.html',
    styleUrls: ['./partner-mart-locations-store-hours.component.scss',
        '../../../../../../../styles/style-layout.scss'
    ],
    providers: [MessageService]
})
export class PartnerMartLocationsStoreHoursComponent implements OnInit {
    @Input()
    public storeId: number = 0;

    @Input()
    public store: any = {};

    public loading: boolean = false;
    public storeData: any = {};
    public operationHours: any[] = [{
        daysWeek: [],
        startTime: null,
        endTime: null
    }];
    public daysWeek: any[] = [
        { name: 'Mon', value: DayOfWeekEnum.Monday },
        { name: 'Tue', value: DayOfWeekEnum.Tuesday },
        { name: 'Wed', value: DayOfWeekEnum.Wednesday },
        { name: 'Thu', value: DayOfWeekEnum.Thursday },
        { name: 'Fri', value: DayOfWeekEnum.Friday },
        { name: 'Sat', value: DayOfWeekEnum.Saturday },
        { name: 'Sun', value: DayOfWeekEnum.Sunday }
    ];

    public showStoreHourSideBar: boolean = false;

    constructor(private messageService: MessageService, private storeService: StoreService) {
    }

    ngOnInit(): void {
        this.getStore();
    }

    getStore() {
        this.loading = true;
        const dto = {
            StoreId: this.storeId
        };

        this.storeService.getStore(dto, this.messageService)
            .then(data => {
                if (!data) {
                    this.loading = false;
                    return;
                }

                if (!data.Success) {
                    this.loading = false;
                    console.log(data.ErrorMessage);
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.storeData = data;
                this.storeFields();
                this.loading = false;
            })
            .catch(error => {
                this.loading = false;
                console.log(error);
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
            });
    }

    storeFields() {
        if (this.storeData.OperationHourItems.length > 0) {
            this.operationHours = [];
            this.storeData.OperationHourItems.forEach((obj: any) => {

                const weekElements = this.daysWeek.filter(element => obj.DayOfWeeks.includes(element.value));

                if (weekElements.length > 0) {
                    this.operationHours.push({
                        daysWeek: weekElements.map((p) => p.name).join(', '),
                        startTime: new Date(obj.StartTime).toLocaleTimeString(), SelectStartTimeIsEmpty: false,
                        endTime: new Date(obj.EndTime).toLocaleTimeString(), SelectEndTimeIsEmpty: false,
                    });
                }
            });
        }

        if (this.storeData.StoreSpecialHours.length > 0) {
            this.storeData.StoreSpecialHours.forEach((obj: any) => {
                obj.StartDate = new Date(obj.StartDate);
                obj.EndDate = new Date(obj.EndDate);
                obj.StartDateStr = new Date(obj.StartDate).toLocaleDateString();
                obj.EndDateStr = new Date(obj.EndDate).toLocaleDateString();
                if (obj.StoreSpecialHourTimes.length > 0) {
                    obj.StoreSpecialHourTimes.forEach((time: any) => {
                        time.OpensAt = new Date(time.OpensAt);
                        time.ClosesAt = new Date(time.ClosesAt);
                        time.OpensAtStr = new Date(time.OpensAt).toLocaleTimeString();
                        time.ClosesAtStr = new Date(time.ClosesAt).toLocaleTimeString();
                    });
                }
            });
        }
    }

    openShowStoreHourSideBar() {
        this.showStoreHourSideBar = true;
    }
    changedShowStoreHourSideBarEmit(value: any) {
        this.showStoreHourSideBar = value;
    }
}
